import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { MultiSelect } from 'primereact/multiselect';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getCurrentCompany, getStyle, SERVICE_FLEET, SERVICE_WORKSHOP, SERVICE_CHAIN, styleMerge, TYPE_CARE_SERVICE, TYPE_WORKSHOP_ALL } from '../../../utils/utils';
import { fetchGarages as _fetchGarages } from '../../../actions/garageActions';
import { fetchMessages as _fetchMessages, deleteMessage as _deleteMessage, fetchMessageDetail as _fetchMessageDetail } from '../../../actions/messageActions';
import AddMessageModal from '../../VehicleDetailsView/VehicleDetailsComponents/AddMessageModal';
import CreateChainMessageModal from '../../ChainView/components/CreateChainMessageModal';
import CBPromptModal from '../../shared/CBPromptModal';
import MessageListItem from './MessageListItem';
import VehicleListTh from '../../OrganizationGarageView/OrganizationGarageComponents/VehicleListTh';
import CBMobileSortSelect from '../../shared/CBMobileSortSelect';
import MessageFilterBar from './MessageFilterBar';
import CBSelectFilters from '../../shared/CBSelectFilters';
import { selectWorkshopChain as _selectWorkshopChain } from '../../../actions/workshopActions';
import { Paginator } from 'primereact/paginator';
import { fetchVehiclesByOrganization as _fetchVehiclesByOrganization, fetchVehiclesForCareService as _fetchVehiclesForCareService } from '../../../actions/vehicleActions';
import { fetchChainCareServiceVehicles as _fetchChainCareServiceVehicles, fetchChainMemberships as _fetchChainMemberships, fetchChainCareServices as _fetchChainCareServices } from '../../../actions/chainActions';

class MessageListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      messageModalIsOpen: false,
      chainMessageModalIsOpen: false,
      deleteModalIsOpen: false,
      search: '',
      ordering: '-created_at',
      fields: [],
      selectedFields: [],
      selectedMessages: [],
      filters: {
      },
      page: 1,
      messageTypeFilter: null,
      approvalStatusFilter: null,
      // Email notifications link to /messages?message=<id>; that message is
      // opened as soon as it is available (see componentDidUpdate).
      autoOpenMessageId: this.readAutoOpenMessageId(),
      autoOpenFetched: false,
    };
    this.tableScrollRef = React.createRef();
    this.topScrollRef = React.createRef();
    this._isSyncingScroll = false;
  }

  readAutoOpenMessageId = () => {
    var messageId = null;
    try {
      var params = new URLSearchParams(window.location.search);
      var raw = params.get('message');
      if (raw && !isNaN(parseInt(raw, 10))) {
        messageId = parseInt(raw, 10);
        // Consume the parameter so a refresh does not reopen the message.
        params.delete('message');
        var rest = params.toString();
        window.history.replaceState(null, '', window.location.pathname + (rest ? '?' + rest : ''));
      }
    } catch (e) {
      messageId = null;
    }
    return messageId;
  };

  getPortalFetchArgs = () => {
    // The same portal identification fetchMessages() is given in refetchMessages.
    const { service, selectedWorkshopId, selectedOrganizationId, selectedChainId } = this.props;
    const effectiveChainId = this.getEffectiveChainId();
    return [
      service === SERVICE_WORKSHOP && selectedWorkshopId,
      service === SERVICE_FLEET && selectedOrganizationId,
      service === SERVICE_CHAIN && selectedChainId,
      service === SERVICE_WORKSHOP && effectiveChainId ? effectiveChainId : undefined,
      service === SERVICE_FLEET && effectiveChainId ? effectiveChainId : undefined,
      this.workshopBelongsToChain(),
    ];
  };

  // Opening a chain-context message retrieves it through the portal endpoint,
  // which records it as read for this user and refreshes it in the list.
  openChainDetail = (message) => {
    const { fetchMessageDetail } = this.props;
    if (!message || !message.id) return;
    fetchMessageDetail.apply(null, [message.id].concat(this.getPortalFetchArgs()));
  };

  clearAutoOpen = () => {
    this.setState({ autoOpenMessageId: null });
  };

  componentDidMount() {
    this.syncTopScrollWidth();
    if (typeof ResizeObserver !== 'undefined' && this.tableScrollRef.current) {
      this._resizeObserver = new ResizeObserver(this.syncTopScrollWidth);
      this._resizeObserver.observe(this.tableScrollRef.current);
    }
  }

  componentWillUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  syncTopScrollWidth = () => {
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      var inner = this.topScrollRef.current.firstChild;
      if (inner) {
        inner.style.width = this.tableScrollRef.current.scrollWidth + 'px';
      }
    }
  };

  handleTopScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.tableScrollRef.current && this.topScrollRef.current) {
      this.tableScrollRef.current.scrollLeft = this.topScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  handleTableScroll = () => {
    if (this._isSyncingScroll) return;
    this._isSyncingScroll = true;
    if (this.topScrollRef.current && this.tableScrollRef.current) {
      this.topScrollRef.current.scrollLeft = this.tableScrollRef.current.scrollLeft;
    }
    this._isSyncingScroll = false;
  };

  componentWillMount() {
    const {
      fetchGarages,
      t,
      fetchMessages,
      service,
      selectedWorkshopId,
      selectedOrganizationId,
      selectedChainId,
      fetchVehiclesByOrganization,
      fetchVehiclesForCareService,
      fetchChainCareServiceVehicles,
    } = this.props;

    const selectedFields = JSON.parse(localStorage.getItem('selectedMessageFields'));

    const allFields = [
      {
        label: t('headingManufacturer'),
        value: 'vehicle_model',
      },
      {
        label: t('headingMessageTitle'),
        value: 'subject',
      },
      {
        label: t('headingMessageSender'),
        value: 'user_display',
      },
      {
        label: t('headingMessageSentAt'),
        value: 'created_at',
      },
      {
        label: t('headingTask'),
        value: 'task',
      },
      {
        label: t('headingReply'),
        value: 'has_response',
      },
      {
        label: t('headingRead'),
        value: 'is_read',
      },
      {
        label: t('headingNewMessage'),
        value: 'new_message',
      },
    ];

    if (this.getCurrentCompany().use_vehicle_identifier) {
      allFields.splice(1, 0, {
        label: t('headingVehicleIdentifier'),
        value: 'vehicle_identifier',
      })
    }

    this.setState({
      fields: allFields,
    });

    this.setState({
      selectedFields: selectedFields || allFields.map((field) => field.value),
    });

    fetchGarages();
    if (service === SERVICE_WORKSHOP) {
      fetchVehiclesForCareService(selectedWorkshopId, {ordering: 'registration_number'});
    } else if (service === SERVICE_FLEET) {
      fetchVehiclesByOrganization(selectedOrganizationId, { ordering: 'registration_number' });
    } else if (service === SERVICE_CHAIN && selectedChainId) {
      fetchChainCareServiceVehicles(selectedChainId, { ordering: 'registration_number' });
    }

    // Load chain memberships and care services for forwarding support
    const effectiveChainId = this.getEffectiveChainId();
    if (effectiveChainId) {
      this.props.fetchChainMemberships(effectiveChainId);
      this.props.fetchChainCareServices(effectiveChainId);
    }

    // Load saved list state per company before initial fetch
    const savedState = this.loadListStateFromStorage();
    if (savedState) {
      const { search, ordering: savedOrdering, filters, page } = savedState;
      this.setState({
        search: search || '',
        ordering: savedOrdering || this.state.ordering,
        filters: filters || this.state.filters,
        page: page || 1,
      }, () => {
        this.refetchMessages(savedOrdering || this.state.ordering, filters || this.state.filters, page || this.state.page, true);
      });
    } else {
      this.refetchMessages();
    }
  }

  getCurrentCompany = () => {
    const {
      user,
      selectedOrganizationId,
      selectedWorkshopId,
      selectedChainId
    } = this.props;

    return getCurrentCompany(user, selectedOrganizationId, selectedWorkshopId, selectedChainId) || {};
  }

  getEffectiveChainId = () => {
    const { user, service, selectedWorkshopId, selectedOrganizationId, selectedChainId, selectedWorkshopChainId } = this.props;
    if (service === SERVICE_CHAIN) return selectedChainId;
    if (service === SERVICE_WORKSHOP && user && user.workshops) {
      const ws = user.workshops.find(function(w) { return w.id == selectedWorkshopId; });
      if (!ws) return null;
      if (ws.workshop_chains && ws.workshop_chains.length > 1) {
        return selectedWorkshopChainId || ws.workshop_chain_id || null;
      }
      return ws.workshop_chain_id || null;
    }
    if (service === SERVICE_FLEET && user && user.organizations) {
      const org = user.organizations.find(function(o) { return o.id == selectedOrganizationId; });
      return org && org.workshop_chain_id ? org.workshop_chain_id : null;
    }
    return null;
  }

  workshopBelongsToChain = () => {
    const { user, service, selectedWorkshopId } = this.props;
    if (service !== SERVICE_WORKSHOP || !user || !user.workshops) return false;
    var ws = user.workshops.find(function(w) { return w.id == selectedWorkshopId; });
    return ws && ws.belongs_to_chain;
  }

  setSelectedFields = (newSelectedFields) => {
    this.setState({
      selectedFields: newSelectedFields,
    });
    JSON.stringify(newSelectedFields);
    localStorage.setItem('selectedMessageFields', JSON.stringify(newSelectedFields));
  }

  getCompanyScopeKey = () => {
    const { service, selectedWorkshopId, selectedOrganizationId, selectedChainId } = this.props;
    if (service === SERVICE_WORKSHOP) {
      return `messageListState:workshop:${selectedWorkshopId || 'none'}`;
    }
    if (service === SERVICE_FLEET) {
      return `messageListState:organization:${selectedOrganizationId || 'none'}`;
    }
    if (service === SERVICE_CHAIN) {
      return `messageListState:chain:${selectedChainId || 'none'}`;
    }
    return 'messageListState:unknown:none';
  }

  saveListStateToStorage = () => {
    const { search, ordering, filters, page } = this.state;
    const key = this.getCompanyScopeKey();
    try {
      localStorage.setItem(key, JSON.stringify({ search, ordering, filters, page }));
    } catch (e) {}
  }

  loadListStateFromStorage = () => {
    const key = this.getCompanyScopeKey();
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  getGarage = () => {
    const { garages, garageId } = this.props;
    return garages.find(garage => garage.id == garageId);
  }

  changeSearchTerms = value => {
    this.setState({
      search: value,
    }, () => {
      this.saveListStateToStorage();
    });
  }

  getSelectedMessages = () => {
    const { selectedMessages } = this.state;
    const { messages } = this.props;

    return messages.filter((msg) => selectedMessages.includes(msg.id));
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
    this.refetchMessages();
  };

  closeUpdateModal = () => {
    this.setState({
      updateModalIsOpen: false,
    });
  };

  closeMessageModal = () => {
    this.setState({
      messageModalIsOpen: false,
    });
  };

  closeDeletePromptModal = () => {
    this.setState({
      deleteModalIsOpen: false,
    });
  };

  afterOpenModal = () => {
  };

  selectVehicle = (messageId) => {
    const { selectedMessages } = this.state;

    const newSelectedMessages = selectedMessages.slice();

    newSelectedMessages.push(messageId);
    this.setState({ selectedMessages: newSelectedMessages });
  };

  unselectVehicle = (messageId) => {
    const { selectedMessages } = this.state;

    const newSelectedMessages = selectedMessages.filter((item) => item !== messageId);

    this.setState({ selectedMessages: newSelectedMessages });
  };

  addCar = () => {
    this.setState({ modalIsOpen: true });
  };

  updateMessages = () => {
    this.setState({ updateModalIsOpen: true });
  };

  sendMessages = () => {
    this.setState({ messageModalIsOpen: true });
  };

  sendChainMessages = () => {
    this.setState({ chainMessageModalIsOpen: true });
  };

  closeChainMessageModal = () => {
    this.setState({ chainMessageModalIsOpen: false });
    this.refetchMessages();
  };

  setMessageTypeFilter = (messageType) => {
    this.setState({
      messageTypeFilter: messageType,
      approvalStatusFilter: null,
      page: 1,
    }, () => {
      this.refetchMessages(null, null, 1);
    });
  };

  setApprovalStatusFilter = (approvalStatus) => {
    this.setState({
      approvalStatusFilter: approvalStatus,
      page: 1,
    }, () => {
      this.refetchMessages(null, null, 1);
    });
  };

  deleteMessages = () => {
    this.setState({ deleteModalIsOpen: true });
  };

  changeFilterTerms = value => {
    this.setState({
      filters: value,
      page: 1, // Reset to page 1 when filters change
    }, () => {
      this.saveListStateToStorage();
      this.refetchMessages(null, value, 1);
    });
  }

  refetchMessages = (newOrdering, newFilters, newPage, isRestored = false) => {
    const {
      fetchMessages,
      garageId,
      service,
      selectedWorkshopId,
      selectedOrganizationId,
      selectedChainId,
    } = this.props;
    const { search, ordering, filters, page, messageTypeFilter, approvalStatusFilter } = this.state;

    const params = {
      search,
      ordering: newOrdering || ordering,
      garage_id: garageId
    };

    // Only force page 1 if we're not restoring saved state and there are actual changes
    if (!isRestored && (newFilters || newOrdering)) {
      params.page = 1;
    } else {
      params.page = newPage || page;
    }

    // Add chain message type filters
    if (messageTypeFilter) {
      params.message_type = messageTypeFilter;
    }
    if (approvalStatusFilter) {
      params.approval_status = approvalStatusFilter;
    }

    const effectiveChainId = this.getEffectiveChainId();
    const workshopChainId = service === SERVICE_WORKSHOP && effectiveChainId ? effectiveChainId : undefined;
    const orgChainId = service === SERVICE_FLEET && effectiveChainId ? effectiveChainId : undefined;

    fetchMessages(
      newFilters ? { ...newFilters, ...params } : { ...filters, ...params },
      service === SERVICE_WORKSHOP && selectedWorkshopId,
      service === SERVICE_FLEET && selectedOrganizationId,
      service === SERVICE_CHAIN && selectedChainId,
      workshopChainId,
      orgChainId,
      this.workshopBelongsToChain(),
    );

    this.saveListStateToStorage();
  };

  changePage = (e) => {
    const newPage = e.page + 1;
    this.setState({
      page: newPage,
    }, () => {
      this.saveListStateToStorage();
      this.refetchMessages(null, null, newPage);
    });
  };

  changeOrdering = (clickedOrdering) => {
    const { ordering } = this.state;
    let newOrdering;
    if (ordering === clickedOrdering) {
      newOrdering = `-${ordering}`;
    } else if (`-${ordering}` === clickedOrdering) {
      newOrdering = 'id';
    } else {
      newOrdering = clickedOrdering;
    }
    this.setState({
      ordering: newOrdering,
      page: 1, // Reset to page 1 when ordering changes
    }, () => {
      this.saveListStateToStorage();
      this.refetchMessages(newOrdering, null, 1);
    });
  };

  getOrderingSymbol = (columnName) => {
    const { ordering } = this.state;
    if (ordering === columnName) {
      return '/img/down_arrow_icon.svg';
    } else if (ordering === `-${columnName}`) {
      return '/img/up_arrow_icon.svg';
    }
    return undefined;
  };

  selectAllMessages = () => {
    const { messages } = this.props;

    const newSelectedMessages = messages.map((message) => message.id);
    this.setState({ selectedMessages: newSelectedMessages });
  };

  unselectAllMessages = () => {
    this.setState({ selectedMessages: [] });
  };

  selectAllChanged = () => {
    const { messages } = this.props;
    const { selectedMessages } = this.state;
    const allChecked = selectedMessages.length === messages.length;

    if (allChecked) {
      this.unselectAllMessages();
    } else {
      this.selectAllMessages();
    }
  }

  componentDidUpdate(prevProps) {
    this.syncTopScrollWidth();
    const { selectedWorkshopId, selectedWorkshopChainId, selectedOrganizationId, selectedChainId, service } = this.props;

    // Deep link: once the list has loaded, fetch the linked message if it is
    // not on this page. The reducer puts it on top and the row opens itself.
    const { messages, messageStatus, fetchMessageDetail } = this.props;
    const { autoOpenMessageId, autoOpenFetched } = this.state;
    if (autoOpenMessageId && !autoOpenFetched
      && messages !== prevProps.messages
      && messageStatus && !messageStatus.loading) {
      const inList = (messages || []).some(function (m) { return m.id === autoOpenMessageId; });
      if (!inList) {
        this.setState({ autoOpenFetched: true }, () => {
          fetchMessageDetail.apply(null, [autoOpenMessageId].concat(this.getPortalFetchArgs()));
        });
      }
    }

    if (selectedWorkshopId != prevProps.selectedWorkshopId
      || selectedWorkshopChainId != prevProps.selectedWorkshopChainId
      || selectedOrganizationId != prevProps.selectedOrganizationId
      || selectedChainId != prevProps.selectedChainId
      || service != prevProps.service) {
      const savedState = this.loadListStateFromStorage();
      if (savedState) {
        const { search, ordering: savedOrdering, filters, page } = savedState;
        this.setState({
          search: search || '',
          ordering: savedOrdering || this.state.ordering,
          filters: filters || this.state.filters,
          page: page || 1,
        }, () => {
          this.refetchMessages(savedOrdering || this.state.ordering, filters || this.state.filters, page || this.state.page, true);
        });
      } else {
        this.setState({ page: 1 }, () => this.refetchMessages());
      }
    }
  }

  applyOrdering = (newOrdering) => {
    this.setState({ ordering: newOrdering, page: 1 }, () => {
      this.saveListStateToStorage();
      this.refetchMessages(newOrdering, null, 1);
    });
  };

  getSortableFields = () => {
    const { t } = this.props;
    var fields = [];
    if (this.getCurrentCompany().use_vehicle_identifier) {
      fields.push({ label: t('headingVehicleIdentifier'), field: 'vehicle_identifier' });
    }
    fields.push({ label: t('headingManufacturer'), field: 'vehicle__manufacturer' });
    fields.push({ label: t('headingMessageTitle'), field: 'subject' });
    fields.push({ label: t('headingMessageSender'), field: 'user__profile__first_name' });
    fields.push({ label: t('headingMessageSentAt'), field: 'created_at' });
    fields.push({ label: t('headingTask'), field: 'task' });
    return fields;
  };

  renderMessageItems = () => {
    const {
      messages,
      removeVehicleFromGarage,
      deleteMessage,
      garageVehicles,
      careServiceVehicles,
      chainCareServiceVehicles,
      service,
      selectedWorkshopId,
      selectedChainId,
    } = this.props;
    const { selectedMessages, selectedFields, autoOpenMessageId } = this.state;
    const garage = this.getGarage();
    const hasChainConnection = service === SERVICE_CHAIN || !!this.getEffectiveChainId();
    const vehicles = service === SERVICE_CHAIN ? chainCareServiceVehicles : (service === SERVICE_WORKSHOP ? careServiceVehicles : garageVehicles);
    return messages.map(message => (
      <MessageListItem
        selectedFields={selectedFields}
        message={message}
        key={message.id}
        garage={garage}
        selected={selectedMessages.includes(message.id)}
        removeVehicleFromGarage={removeVehicleFromGarage}
        select={this.selectVehicle}
        unselect={this.unselectVehicle}
        deleteMessage={deleteMessage}
        service={service}
        selectedWorkshopId={selectedWorkshopId}
        selectedChainId={selectedChainId}
        vehicles={vehicles}
        useVehicleIdentifier={this.getCurrentCompany().use_vehicle_identifier}
        hasChainConnection={hasChainConnection}
        openChainDetail={this.openChainDetail}
        autoOpenMessageId={autoOpenMessageId}
        onAutoOpened={this.clearAutoOpen}
      />
    ));
  };

  render() {
    const {
      messages,
      t,
      removeVehicleFromGarage,
      user,
      deleteMessage,
      garageVehicles,
      careServiceVehicles,
      chainCareServiceVehicles,
      service,
      selectedWorkshopId,
      selectedChainId,
      pagination,
    } = this.props;

    const {
      selectedMessages,
      messageModalIsOpen,
      chainMessageModalIsOpen,
      deleteModalIsOpen,
      filters,
      messageTypeFilter,
      approvalStatusFilter,
    } = this.state;

    const { modalIsOpen, fields, selectedFields } = this.state;
    const garage = this.getGarage();
    const isChain = service === SERVICE_CHAIN;
    const hasChainConnection = isChain || !!this.getEffectiveChainId();

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'topBarsContainer')}>
              <MessageFilterBar
                useIdentifiers={this.getCurrentCompany().use_vehicle_identifier}
                changeSearchTerms={this.changeSearchTerms}
                refetchMessages={this.refetchMessages}
                sendMessages={hasChainConnection ? this.sendChainMessages : this.sendMessages}
                filters={filters}
                search={this.state.search}
                changeFilterTerms={this.changeFilterTerms}
              />

              {hasChainConnection && (
                <div style={getStyle(screenSize, styles, 'filterTabsContainer')}>
                  <div style={getStyle(screenSize, styles, 'filterTabs')}>
                    <button
                      style={styleMerge(
                        getStyle(screenSize, styles, 'filterTab'),
                        !messageTypeFilter ? getStyle(screenSize, styles, 'filterTabActive') : {}
                      )}
                      onClick={() => this.setMessageTypeFilter(null)}
                    >
                      {t('filterAll')}
                    </button>
                    <button
                      style={styleMerge(
                        getStyle(screenSize, styles, 'filterTab'),
                        messageTypeFilter === 'vehicle' ? getStyle(screenSize, styles, 'filterTabActive') : {}
                      )}
                      onClick={() => this.setMessageTypeFilter('vehicle')}
                    >
                      {t('filterVehicleMessages')}
                    </button>
                    <button
                      style={styleMerge(
                        getStyle(screenSize, styles, 'filterTab'),
                        messageTypeFilter === 'chain_message' ? getStyle(screenSize, styles, 'filterTabActive') : {}
                      )}
                      onClick={() => this.setMessageTypeFilter('chain_message')}
                    >
                      {t('filterChainMessages')}
                    </button>
                    {/* Lupapyyntö and Saatavuuskysely are workshop <-> chain traffic;
                        a fleet customer never sees them, so no tab for them there. */}
                    {service !== SERVICE_FLEET && (
                      <button
                        style={styleMerge(
                          getStyle(screenSize, styles, 'filterTab'),
                          messageTypeFilter === 'approval_request' ? getStyle(screenSize, styles, 'filterTabActive') : {}
                        )}
                        onClick={() => this.setMessageTypeFilter('approval_request')}
                      >
                        {t('filterApprovalRequests')}
                      </button>
                    )}
                    {service !== SERVICE_FLEET && (
                      <button
                        style={styleMerge(
                          getStyle(screenSize, styles, 'filterTab'),
                          messageTypeFilter === 'availability_inquiry' ? getStyle(screenSize, styles, 'filterTabActive') : {}
                        )}
                        onClick={() => this.setMessageTypeFilter('availability_inquiry')}
                      >
                        {t('filterAvailabilityInquiries')}
                      </button>
                    )}
                    <button
                      style={styleMerge(
                        getStyle(screenSize, styles, 'filterTab'),
                        messageTypeFilter === 'customer_approval' ? getStyle(screenSize, styles, 'filterTabActive') : {}
                      )}
                      onClick={() => this.setMessageTypeFilter('customer_approval')}
                    >
                      {t('filterCustomerApprovals')}
                    </button>
                  </div>

                  {(messageTypeFilter === 'approval_request' || messageTypeFilter === 'customer_approval') && (
                    <div style={getStyle(screenSize, styles, 'filterTabs')}>
                      <button
                        style={styleMerge(
                          getStyle(screenSize, styles, 'filterSubTab'),
                          !approvalStatusFilter ? getStyle(screenSize, styles, 'filterTabActive') : {}
                        )}
                        onClick={() => this.setApprovalStatusFilter(null)}
                      >
                        {t('filterAll')}
                      </button>
                      <button
                        style={styleMerge(
                          getStyle(screenSize, styles, 'filterSubTab'),
                          approvalStatusFilter === 'pending' ? getStyle(screenSize, styles, 'filterTabActive') : {}
                        )}
                        onClick={() => this.setApprovalStatusFilter('pending')}
                      >
                        {t('filterPending')}
                      </button>
                      <button
                        style={styleMerge(
                          getStyle(screenSize, styles, 'filterSubTab'),
                          approvalStatusFilter === 'approved' ? getStyle(screenSize, styles, 'filterTabActive') : {}
                        )}
                        onClick={() => this.setApprovalStatusFilter('approved')}
                      >
                        {t('filterApproved')}
                      </button>
                      <button
                        style={styleMerge(
                          getStyle(screenSize, styles, 'filterSubTab'),
                          approvalStatusFilter === 'rejected' ? getStyle(screenSize, styles, 'filterTabActive') : {}
                        )}
                        onClick={() => this.setApprovalStatusFilter('rejected')}
                      >
                        {t('filterRejected')}
                      </button>
                    </div>
                  )}

                  {service === SERVICE_WORKSHOP && (function () {
                    var ws = user && user.workshops && user.workshops.find(function (w) { return w.id == selectedWorkshopId; });
                    if (ws && ws.workshop_chains && ws.workshop_chains.length > 1) {
                      return (
                        <div style={{ marginLeft: 16, display: 'inline-block' }}>
                          <CBSelectFilters
                            name='chain_filter'
                            options={[{ value: '', label: t('filterAllChains') }].concat(
                              ws.workshop_chains.map(function (c) { return { value: String(c.id), label: c.name }; })
                            )}
                            onChange={function (changed) {
                              this.props.selectWorkshopChain(changed.chain_filter ? parseInt(changed.chain_filter) : null);
                            }.bind(this)}
                            value={this.props.selectedWorkshopChainId ? String(this.props.selectedWorkshopChainId) : ''}
                            selectStyle={{ marginLeft: 0, marginRight: 0, width: 200 }}
                          />
                        </div>
                      );
                    }
                    return null;
                  }).call(this)}
                </div>
              )}

              <hr style={{ opacity: '30%' }} />
            </div>

            {screenSize === 'small' ? (
              <div style={getStyle(screenSize, styles, 'mobileListContainer')}>
                <CBMobileSortSelect
                  fields={this.getSortableFields()}
                  ordering={this.state.ordering}
                  onChange={this.applyOrdering}
                />
                {this.renderMessageItems()}
                {this.props.pagination && (
                  <Paginator
                    first={(this.props.pagination.page_size * this.props.pagination.current_page - 1)}
                    rows={this.props.pagination.page_size}
                    totalRecords={this.props.pagination.count}
                    onPageChange={this.changePage}
                  />
                )}
              </div>
            ) : (
            <React.Fragment>
            <div
              ref={this.topScrollRef}
              onScroll={this.handleTopScroll}
              style={getStyle(screenSize, styles, 'topScrollbar')}
              className="vehicle-table-scrollbar"
            >
              <div style={getStyle(screenSize, styles, 'topScrollbarInner')} />
            </div>
            <div
              ref={this.tableScrollRef}
              onScroll={this.handleTableScroll}
              style={getStyle(screenSize, styles, 'tableContainer')}
              className="vehicle-table-scrollbar"
            >
              <table style={getStyle(screenSize, styles, 'table')}>
                <thead>
                  <tr>
                    {
                    /*
                    <th style={styleMerge(getStyle(screenSize, styles, 'tableHeaderFirst'), getStyle(screenSize, styles, 'alignCenter'))}>
                      <CBLabelAndCheckbox
                        checked={selectedMessages.length === messages.length}
                        additionalStyles={{ justifyContent: 'center' }}
                        onChange={this.selectAllChanged}
                      />
                    </th>
                    */
                    }

                    {
                      selectedFields.includes('image') && (
                        <th style={getStyle(screenSize, styles, 'tableHeader')} />
                      )
                    }

                    {
                      selectedFields.includes('vehicle_identifier') && this.getCurrentCompany().use_vehicle_identifier && (
                        <VehicleListTh
                          text={t('headingVehicleIdentifier')}
                          fieldName='vehicle_identifier'
                          orderingSymbol={this.getOrderingSymbol('vehicle_identifier')}
                          changeOrdering={() => {
                            this.changeOrdering('vehicle_identifier');
                          }}
                        />
                      )
                    }

                    <VehicleListTh
                      text={t('headingRegistrationNumber')}
                      fieldName='vehicle_registration_number'
                      orderingSymbol={this.getOrderingSymbol('vehicle_registration_number')}
                      changeOrdering={() => {
                        this.changeOrdering('vehicle_registration_number');
                      }}
                      notSortable
                    />

                    {
                      selectedFields.includes('vehicle_model') && (
                        <VehicleListTh
                          text={t('headingManufacturer')}
                          fieldName='vehicle_model'
                          orderingSymbol={this.getOrderingSymbol('vehicle__manufacturer')}
                          changeOrdering={() => {
                            this.changeOrdering('vehicle__manufacturer');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('subject') && (
                        <VehicleListTh
                          text={t('headingMessageTitle')}
                          fieldName='subject'
                          orderingSymbol={this.getOrderingSymbol('subject')}
                          changeOrdering={() => {
                            this.changeOrdering('subject');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('user_display') && (
                        <VehicleListTh
                          text={t('headingMessageSender')}
                          fieldName='user_display'
                          orderingSymbol={this.getOrderingSymbol('user__profile__first_name')}
                          changeOrdering={() => {
                            this.changeOrdering('user__profile__first_name');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('created_at') && (
                        <VehicleListTh
                          text={t('headingMessageSentAt')}
                          fieldName='created_at'
                          orderingSymbol={this.getOrderingSymbol('created_at')}
                          changeOrdering={() => {
                            this.changeOrdering('created_at');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('task') && (
                        <VehicleListTh
                          text={t('headingTask')}
                          fieldName='task'
                          orderingSymbol={this.getOrderingSymbol('task')}
                          changeOrdering={() => {
                            this.changeOrdering('task');
                          }}
                        />
                      )
                    }

                    {
                      selectedFields.includes('has_response') && (
                        <VehicleListTh
                          text={t('headingReply')}
                          fieldName='has_response'
                          orderingSymbol={this.getOrderingSymbol('has_response')}
                          changeOrdering={() => {
                            this.changeOrdering('has_response');
                          }}
                          notSortable
                        />
                      )
                    }

                    {
                      selectedFields.includes('is_read') && (
                        <VehicleListTh
                          text={t('headingRead')}
                          fieldName='is_read'
                          orderingSymbol={this.getOrderingSymbol('is_read')}
                          changeOrdering={() => {
                            this.changeOrdering('is_read');
                          }}
                          notSortable
                        />
                      )
                    }


                    {
                      selectedFields.includes('new_message') && (
                        <VehicleListTh
                          text={t('headingNewMessage')}
                          fieldName='new_message'
                          notSortable
                        />
                      )
                    }

                    <th style={getStyle(screenSize, styles, 'tableHeaderSettings')}>
                      <MultiSelect
                        value={selectedFields}
                        onChange={(e) => this.setSelectedFields(e.value)}
                        options={fields}
                        className="bars"
                        dropdownIcon={undefined}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderMessageItems()}
                </tbody>
              </table>
              {this.props.pagination && (
                <Paginator
                  first={(this.props.pagination.page_size * this.props.pagination.current_page - 1)}
                  rows={this.props.pagination.page_size}
                  totalRecords={this.props.pagination.count}
                  onPageChange={this.changePage}
                />
              )}
            </div>
            </React.Fragment>
            )}
            {messageModalIsOpen && (
              <AddMessageModal
                modalIsOpen={messageModalIsOpen}
                closeModal={this.closeMessageModal}
                selectedMessages={this.getSelectedMessages()}
                vehicles={service === SERVICE_CHAIN ? chainCareServiceVehicles : (service === SERVICE_WORKSHOP ? careServiceVehicles : garageVehicles)}
              />
            )}
            {chainMessageModalIsOpen && (function () {
              var modalChainId = this.getEffectiveChainId();
              if (service === SERVICE_WORKSHOP && user && user.workshops) {
                var ws = user.workshops.find(function (w) { return w.id == selectedWorkshopId; });
                if (ws && ws.workshop_chains && ws.workshop_chains.length > 1 && !this.props.selectedWorkshopChainId) {
                  modalChainId = null;
                }
              }
              return (
                <CreateChainMessageModal
                  modalIsOpen={chainMessageModalIsOpen}
                  closeModal={this.closeChainMessageModal}
                  chainId={modalChainId}
                  service={service}
                  vehicles={service === SERVICE_CHAIN ? chainCareServiceVehicles : (service === SERVICE_WORKSHOP ? careServiceVehicles : garageVehicles)}
                />
              );
            }).call(this)}
            {deleteModalIsOpen && (
              <CBPromptModal
                modalIsOpen={deleteModalIsOpen}
                closeModal={this.closeDeletePromptModal}
                afterOpenModal={() => {}}
                title={t('deleteManyFromGaragePromptTitle')}
                text={`${t('deleteManyFromGaragePromptText')}`}
                buttonText={t('deleteButton')}
                performAction={() => {
                  removeVehicleFromGarage(undefined, garage.id, selectedMessages);
                  this.closeDeletePromptModal();
                  this.unselectAllMessages();
                }}
              />
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      width: '100%',
      padding: '0px 16px 0px 0px',
    },
    mobileListContainer: {
      padding: '0 16px 24px 16px',
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 20,
    },
    searchContainer: {
      maxWidth: 600,
    },
    tableContainer: {
      width: '100%',
      overflowX: 'auto',
      marginBottom: '24px',
      paddingBottom: 16,
      position: 'relative',
    },
    table: {
      whiteSpace: 'nowrap',
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    topScrollbar: {
      overflowX: 'auto',
      overflowY: 'hidden',
      width: '100%',
      marginTop: 12,
    },
    topScrollbarInner: {
      height: 1,
    },
    tableHeader: {
      fontFamily: 'TitilliumWeb-Bold',
      color: '#FFFFFF',
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      padding: '8px 8px 8px 8px',
    },
    tableHeaderSettings: {
      cursor: 'pointer',
      WebkitUserSelect: 'none',
      MsUserSelect: 'none',
      UserSelect: 'none',
      //position: 'sticky',
      padding: '8px 8px 8px 8px',
      right: 0,
    },
    tableHeaderFirst: {
      //position: 'sticky',
      left: 0,
    },
    alignCenter: {
      textAlign: 'center',
    },
    topBarsContainer: {
      marginTop: 32,
      paddingLeft: 16,
    },
    filterTabsContainer: {
      marginTop: 8,
      marginBottom: 8,
    },
    filterTabs: {
      display: 'flex',
      flexDirection: 'row',
      gap: 4,
      marginBottom: 4,
    },
    filterTab: {
      fontFamily: 'TitilliumWeb-Regular',
      fontSize: 14,
      color: '#FFFFFF',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: 4,
      padding: '6px 12px',
      cursor: 'pointer',
    },
    filterSubTab: {
      fontFamily: 'TitilliumWeb-Regular',
      fontSize: 12,
      color: '#FFFFFF',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.15)',
      borderRadius: 4,
      padding: '4px 10px',
      cursor: 'pointer',
    },
    filterTabActive: {
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
  },
  medium: {
    table: {
    },
  },
  small: {
    table: {
    },
    container: {
      padding: 0,
    },
    topBarsContainer: {
      paddingRight: 16,
    },
    filterTabs: {
      flexWrap: 'wrap',
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    garages: state.garage.garages,
    messages: state.message.messages,
    pagination: state.message.pagination,
    messageStatus: state.message.messageStatus,
    service: state.app.service,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedWorkshopChainId: state.workshop.selectedWorkshopChainId,
    selectedOrganizationId: state.organization.selectedOrganization,
    selectedChainId: state.chain.selectedChainId,
    careServiceVehicles: state.vehicle.careServiceVehicles,
    garageVehicles: state.vehicle.garageVehicles,
    chainCareServiceVehicles: state.chain.chainCareServiceVehicles,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchGarages: _fetchGarages,
    fetchMessages: _fetchMessages,
    deleteMessage: _deleteMessage,
    fetchMessageDetail: _fetchMessageDetail,
    fetchVehiclesByOrganization: _fetchVehiclesByOrganization,
    fetchVehiclesForCareService: _fetchVehiclesForCareService,
    fetchChainCareServiceVehicles: _fetchChainCareServiceVehicles,
    fetchChainMemberships: _fetchChainMemberships,
    fetchChainCareServices: _fetchChainCareServices,
    selectWorkshopChain: _selectWorkshopChain,
  },
)(translate('MessageListView')(MessageListView));
